"use client";

import { Carousel as Cawousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "./ui/carousel";
import Image from "next/image";
import { StaticImport } from "next/dist/shared/lib/get-img-props";
import Autoplay from "embla-carousel-autoplay";
import { cn } from "@/lib/utils";

export interface ImageType {
    source: StaticImport;
    alt: string;
}

export interface CarouselProps {
    images: ImageType[];
    className?: string;
    autoplay?: boolean;
    preload?: boolean;
}

export function Carousel({ images, className, autoplay, preload }: CarouselProps) {
    const plugins = [];
    if (autoplay) plugins.push(Autoplay({ delay: 2000 }));

    return <div className="flex w-full justify-center">
        <Cawousel className={cn("md:w-3/4 lg:w-1/2 xl:w-1/3", className)} plugins={plugins}>
        <CarouselContent className="flex items-center">
            {images.map((img, i) => <CarouselItem key={i}>
                <Image alt={img.alt} src={img.source} priority={preload} />
            </CarouselItem>)}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
    </Cawousel>
    </div>
}
